import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  footer: {
    height: "50px",
    paddingRight: "30px",
    "& span": {
      fontSize: "0.875em",
      marginRight: "3px",
    },
    "& img": {
      height: "15px",
      paddingLeft: "5px",
    },
    '@media(max-width: 470px)': {
      display: "none",
    }
  },
  whiteBG: {
    borderTop: `1px solid ${colors.borderGrey}`,
    boxSizing: "border-box",
    backgroundColor: colors.white,
  },
};

const PoweredBy = (props) => {
  const { classes } = props;

  return (
    <Grid
      container
      alignItems="center"
      justify="flex-end"
      className={`${classes.footer} ${props.whiteBG ? classes.whiteBG : ""}`}
    >
      <Grid item className="text-54">
        {I18n.get("footer_poweredBy")}
      </Grid>
      <Grid item className="flexCenter">
        <Link href={"https://www.jrv.com"} rel="noopener" target="_blank">
          <img src={images.nuvoolaLogo} alt="jrv_logo" />
        </Link>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(PoweredBy);
